export default [
  {
    path: '/podcasts',
    name: 'podcasts',
    component: () => import('../../views/podcasts/podcasts.vue'),
    meta: {
      pageTitle: 'Podcasts',
      breadcrumbs: ['Podcasts'],
    },
    children: [
      {
        path: '',
        name: 'podcasts-list',
        component: () => import('../../views/podcasts/list.vue')
      },
      {
        path: 'create',
        name: 'podcasts-create',
        component: () => import('../../views/podcasts/create.vue'),
        meta: {
          pageTitle: 'Create Podcast',
          breadcrumbs: ['Podcasts', 'Create'],
        }
      },
      {
        path: 'download-audio',
        name: 'podcasts-download-audio',
        component: () => import('../../views/podcasts/download-audio.vue'),
        meta: {
          pageTitle: 'Download Audio',
          breadcrumbs: ['Podcasts', 'Download Audio'],
        }
      },
      {
        path: ':id/edit',
        name: 'podcasts-edit',
        component: () => import('../../views/podcasts/edit.vue'),
        meta: {
          pageTitle: 'Edit Podcast',
          breadcrumbs: ['Podcasts', 'Edit'],
        }
      },
      {
        path: ':id/episodes',
        name: 'podcast-episodes',
        component: () => import('../../views/podcasts/episodes.vue'),
        meta: {
          pageTitle: 'Podcast Episodes',
          breadcrumbs: ['Podcasts', 'Episodes'],
        }
      }
    ]
  }
]
